import { ThemeMode, useSettingsStore } from '@annunciate/core';
export const useThemeOrDefault = () => {
    return useSettingsStore((state) => {
        return state.themeMode ||
            useSettingsStore.getState().themeMode ||
            state.defaultThemeMode ||
            useSettingsStore.getState().defaultThemeMode ||
            ThemeMode.SYSTEM;
    });
};
//# sourceMappingURL=useThemeOrDefault.js.map